<template>
  <div class="topics">
    <h1>课程选题</h1>
    <section>
      <h3>选题1：数据驱动的古典文献目录分析</h3>
      <h4>选题目标</h4>
      <p>
        借助计算方法基于目录中的具体典籍进行跨时代的目录分类演变分析、官司目录分类体系对比、典籍存佚分析等
      </p>
      <h4>可选数据集</h4>
      <p>历代史志目录、私家目录、四库全书总目等</p>
      <h4>研究框架及方法</h4>
      <p>
        利用正则表达式对书目信息进行结构化处理，人工进行规范化及书目认同，统计分析及可视化
      </p>
      <h4>参考文献</h4>
      <li>
        李惠, 陈涛, 侯君明, 等. 钩玄提要——古籍目录智能分析工具构建[J].
        中国图书馆学报, 2021, 47(04): 97-112.
      </li>
      <li>
        李瑞龙, 李明杰. 数字人文背景下古典目录学“辨考”思想的实现路径初探[J].
        山东图书馆学刊, 2019(01): 14-19+40.
      </li>
      <li>
        夏翠娟, 林海青, 刘炜. 面向循证实践的中文古籍数据模型研究与设计[J].
        中国图书馆学报, 2017, 43(06): 16-34.
      </li>
      <li>
        LI W, WANG F, WANG J. Exploring the Classification of Traditional
        Chinese Bibliographies through Interactive Visualization[C]//2021
        ACM/IEEE Joint Conference on Digital Libraries (JCDL). 2021: 246-249.
      </li>
    </section>
    <hr />

    <section>
      <h3>选题2：文化遗产本体构建</h3>
      <h4>选题目标</h4>
      从文献中提取数据，构建文化遗产本体
      <h4>数据集</h4>
      <li>《中国出土青铜器全集》、《中国陶瓷全集》、玉器等出土文献全集：</li>
      <li>需要对文献进行文本和图像数据提取</li>
      <h4>研究框架及方法</h4>
      <li>
        文化遗产本体构建：提取数据，分析对象的特征，定义概念，关系、属性，评估
      </li>
      <li>研究工具：Protege、Cmap等</li>
      <h4>参考文献</h4>
      <li>
        Wei T, Roche C, Papadopoulou M, Jia Y. Using ISO and Semantic Web
        standard for building a multilingual terminology e-Dictionary: A use
        case of Chinese ceramic vases. Journal of Information Science. June
        2021. doi:10.1177/01655515211022185
      </li>
      <li>
        C.Roche. Ontoterminology: How to unify terminology and ontology into a
        single paradigm . LREC 2012, Eighth international conference on Language
        Resources and Evaluation, Istanbul (Turkey), 21-27 May 2012, pp.
        2626-2630
      </li>
      <li>
        C.Roche . Saying is not modelling. NLPCS 2007, Natural Language
        Processing and Cognitive Science, Funchal (Portugal), 12-13 June 2007,
        pp. 47-56
      </li>
      <li>
        Nicola Guarino, Daniel Oberle, and Steffffen Staab. What Is an Ontology?
        . Handbook on Ontologies.
      </li>
    </section>
    <hr />
    <section>
      <h3>选题3：历史人物网络分析</h3>
      <h4>选题目标</h4>
      <p>
        熟悉历史人物数据库，使用社会网络分析的理论和方法进行数字人文研究实践，以理解历史制度、社会和文化背景。
      </p>
      <h4>可选数据集</h4>
      <li>
        根据研究问题构建数据集，可参考材料范围有：《明儒学案》、《四库全书总目提要》
      </li>
      <li>
        历史人物数据库 ：中国历代人物传记资料库（CBDB）、上海图书馆人名规范库等
      </li>
      <h4>研究框架及方法</h4>
      <li>
        通过人工检索、著录或整合现有历史人物数据库或其他自然语言处理技术构建数据集，需包括节点数据与边（节点的关系）数据；
      </li>
      <li>进行网络分析与可视化，常见工具有Gephi、Pajek等。</li>
      <h4>参考文献</h4>
      <li>
        刘飞燕,高剑波.隋唐至宋时期精英社会网络动力学的演化研究[J].数字人文,2020(00):118-127.
      </li>
      <li>
        赵薇.社会网络分析与“《大波》三部曲”的人物功能[J].山东社会科学,2018(09):50-64.
      </li>
      <li>
        Shang W, Sang Z. Solidity in a Turbulent Flow: The Social Network of
        Aristocratic Families in the Eastern Jin Dynasty (317–420 CE)[J].
        Journal of Historical Network Research, 2022, 5(1).
      </li>
      <li>
        Xiong, H.-L. Path toward the Top Leadership: A Network Analysis of the
        Civil Service System in the Early Southern Song (1131-1164)[J]. Journal
        of Historical Network Research, 2022,5(1).
      </li>
    </section>
    <hr />

    <section>
      <h3>选题4：文化分析</h3>
      <h4>选题目标</h4>
      <p>
        运用计算机手段，对一定规模古典文献文本数据进行量化处理，进而发现并分析文化现象。
      </p>
      <h4>可选数据集</h4>
      <p>古腾堡语料库、美国当代英语语料库（COCA）、殆知阁古文文本数据集</p>
      <h4>研究框架及方法</h4>
      <li>
        利用Python预处理较大规模的文本数据，围绕某一特定的文化现象进行多角度的量化分析，从而探索其发展规律或内在联系，并进行可视化展示。包括文本数据清洗、词频统计、获取词向量、文本相似关系检测、数据可视化等。
      </li>
      <li>常见工具有google n-gram，COCA，北语BCC，Python等。</li>
      <h4>参考文献</h4>
      <li>
        Michel J B , Yuan K S , Aiden A P , et al. Quantitative analysis of
        culture using millions of digitized books.[J]. Science, 2010,
        331(6014):176-182.
      </li>
      <li>
        Garg N , Schiebinger L , Jurafsky D , et al. Word embeddings quantify
        100 years of gender and ethnic stereotypes[J]. Proceedings of the
        National Academy of Sciences of the United States of America, 2018,
        115(16):E3635.
      </li>
      <li>
        Dexter J P , Katz T , Tripuraneni N , et al. Quantitative criticism of
        literary relationships[J]. Proceedings of the National Academy of
        Sciences of the United States of America, 2017.
      </li>
    </section>
    <hr />

    <section>
      <h3>（更多选题待添加）</h3>
    </section>
  </div>
</template>

<script>
export default {
  name: "Topics",
};
</script>

<style lang="less" scoped>
.topics {
  padding: 1rem 0;
  h1 {
    text-align: center;
    letter-spacing: 0.4rem;
    font-weight: normal;
    margin: 0 0 1rem;
  }

  section {
    margin: 0 0 2rem;
    h4,
    p {
      margin: 0.3rem 0;
      line-height: 1.2rem;
      letter-spacing: 0.04rem;
    }
    li {
      line-height: 1.2rem;
      letter-spacing: 0.04rem;
    }

    h3 {
      margin: 1rem 0 0.3rem;
    }
  }
}
</style>
